"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.inImageCache = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Layout = require("../Layout");

var _imageUrl = require("../../utils/imageUrl");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var makeUrlParams = function makeUrlParams(props) {
  var urlParams = props.urlParams,
      imgFormat = props.imgFormat,
      quality = props.quality;
  var external = props.external;

  if (!external) {
    imgFormat = typeof imgFormat === "boolean" ? imgFormat ? "f_auto" : '' : imgFormat;
    quality = typeof quality === "boolean" ? quality ? "q_auto" : '' : typeof quality === "string" && quality.includes("q_auto") ? "q_auto:".concat(quality) : quality;

    if (!urlParams || !urlParams.length) {
      urlParams = 'c_fill';
    }

    var toUrl = [imgFormat, quality, urlParams, 'dpr_auto'].filter(function (e) {
      return e && e.length;
    });
    return toUrl.join(',');
  }

  return false;
};

var imageCache = {};

var inImageCache = function inImageCache(props, imageName, hostName) {
  if (props !== null && props !== void 0 && props.fluid || props !== null && props !== void 0 && props.fixed) {
    var image = props.fluid || props.fixed;
    var urlParams = makeUrlParams(props);
    urlParams = props.fluid ? "".concat(urlParams, ",w_").concat(image.maxWidth) : "".concat(urlParams, ",w_").concat(image.width, ",h_").concat(image.height);

    if (hostName && imageName) {
      var src = "https://".concat(hostName, "/").concat(urlParams, "/").concat(imageName);

      if (imageCache[src]) {
        return true;
      }

      imageCache[src] = true;
    } else {
      throw new Error('We not received hostName or imageName params.');
    }
  } else {
    throw new Error('We need a fluid size or fixed size.');
  }
};

exports.inImageCache = inImageCache;
var io;
var listeners = [];

function getIO() {
  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
    io = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        listeners.forEach(function (l) {
          if (l[0] === entry.target) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              io.unobserve(l[0]);
              l[1]();
            }
          }
        });
      });
    }, {
      rootMargin: "100px"
    });
  }

  return io;
}

var listenToIntersections = function listenToIntersections(el, cb) {
  getIO().observe(el);
  listeners.push([el, cb]);
};

var noscriptImg = function noscriptImg(props) {
  var src = props.src ? "src=\"".concat(props.src, "\" ") : 'src="" ';
  var title = props.title && "title=\"".concat(props.title, "\" ");
  var alt = "alt=\"".concat(props.alt, "\"");
  var width = props.width && "width=\"".concat(props.width, "\" ");
  var height = props.height && "height=\"".concat(props.height, "\" ");
  var opacity = props.opacity ? props.opacity : '1';
  var transitionDelay = props.transitionDelay ? props.transitionDelay : '0.5s';
  return "<img ".concat(width).concat(height).concat(src).concat(alt).concat(title, "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:").concat(transitionDelay, ";opacity:").concat(opacity, ";width:100%;height:100%;object-fit:cover;object-position:center\"/>");
};

var Img = _react.default.forwardRef(function (props, ref) {
  var style = props.style,
      onLoad = props.onLoad,
      onError = props.onError,
      alt = props.alt,
      rest = (0, _objectWithoutProperties2.default)(props, ["style", "onLoad", "onError", "alt"]);
  return _react.default.createElement("img", (0, _extends2.default)({
    alt: alt,
    onLoad: onLoad,
    onError: onError,
    ref: ref,
    style: _objectSpread({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center"
    }, style)
  }, rest));
});

Img.defaultProps = {
  style: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center"
  },
  onError: null,
  onLoad: null,
  alt: ''
};
var ImageWrapper = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Image__ImageWrapper",
  componentId: "pzl79f-0"
})(_styledSystem.border, (0, _styledSystem.variant)({
  prop: 'hasBorder',
  variants: {
    true: {
      border: '2px solid white'
    }
  }
}));

var Image = function Image(props) {
  var hasBorder = props.hasBorder,
      external = props.external,
      fixed = props.fixed,
      fluid = props.fluid,
      onLoad = props.onLoad,
      title = props.title,
      alt = props.alt,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      _props$imgStyle = props.imgStyle,
      imgStyle = _props$imgStyle === void 0 ? {} : _props$imgStyle,
      _props$placeholderSty = props.placeholderStyle,
      placeholderStyle = _props$placeholderSty === void 0 ? {} : _props$placeholderSty,
      isPlaceholder = props.isPlaceholder,
      backgroundColor = props.backgroundColor,
      borderRadius = props.borderRadius,
      onError = props.onError,
      src = props.src,
      draggable = props.draggable,
      onDragStart = props.onDragStart;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      imgLoaded = _useState4[0],
      setImgLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      originalAspectRatio = _useState6[0],
      setOriginalAspectRatio = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      IOSupported = _useState8[0],
      setIOSupported = _useState8[1];

  var _useState9 = (0, _react.useState)(props.fadeIn),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      fadeIn = _useState10[0],
      setFadeIn = _useState10[1];

  var hostName;
  var imageName;
  var seenBefore;

  if (!isPlaceholder) {
    hostName = (0, _imageUrl.getHost)(src);

    if (!external) {
      imageName = (0, _imageUrl.getImageRouteFromUrl)(src, '/v');
    } else {
      imageName = (0, _imageUrl.getImageRouteFromUrl)(src, hostName);
    }

    seenBefore = inImageCache(props, imageName, hostName);

    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
      setIsVisible(false);
      setImgLoaded(false);
      setIOSupported(true);
    }

    if (typeof window === "undefined") {
      setIsVisible(true);
      setImgLoaded(true);
    }
  }

  var hasNoScript = fadeIn;
  var refImage = (0, _react.useRef)();

  var createBrakePointsFluid = function createBrakePointsFluid(url) {
    var image = fluid;
    var step = image.breakpointStep || 150;
    var size = 150;
    var results = [];

    while (size < image.maxWidth) {
      var params = "".concat(url, ",w_").concat(size);
      results.push("https://".concat(hostName, "/").concat(params, "/").concat(imageName, " ").concat(size, "w"));
      size += step;
    }

    results.push("https://".concat(hostName, "/").concat(url, ",w_").concat(image.maxWidth, "/").concat(imageName, " ").concat(image.maxWidth, "w"));
    return results.join(',');
  };

  var createBrakePointsFixed = function createBrakePointsFixed(url) {
    var results = [];
    var image = fixed;

    for (var i = 1; i < 3; i += 1) {
      var params = "".concat(url, ",w_").concat(image.width * i, ",h_").concat(image.height * i);
      results.push("https://".concat(hostName, "/").concat(params, "/").concat(imageName, " ").concat(i, "x"));
    }

    return results.join(',');
  };

  var handleImageLoaded = function handleImageLoaded(e) {
    setImgLoaded(true);
    setOriginalAspectRatio(e.target.naturalWidth / e.target.naturalHeight);

    if (seenBefore) {
      setFadeIn(false);
    }

    onLoad && onLoad();
  };

  var handleRef = function handleRef(ref) {
    if (IOSupported && ref) {
      listenToIntersections(ref, function () {
        setIsVisible(true);
      });
    }
  };

  var image;
  var srcSet;
  var urlParams = makeUrlParams(props);
  var bgColor = typeof backgroundColor === "boolean" || isPlaceholder ? "#e0e0e0" : backgroundColor;

  var imageStyle = _objectSpread({
    opacity: imgLoaded || fadeIn === false ? 1 : 0,
    transition: fadeIn === true ? "opacity 0.5s" : "none",
    backgroundColor: isPlaceholder && bgColor
  }, imgStyle);

  if (fluid) {
    image = fluid;
    srcSet = createBrakePointsFluid(urlParams);
    urlParams = "".concat(urlParams, ",w_").concat(image.maxWidth);
    var aspectRatio = image.aspectRatio || originalAspectRatio;
    return _react.default.createElement(ImageWrapper, {
      hasBorder: hasBorder,
      borderRadius: borderRadius,
      style: _objectSpread({
        position: "relative",
        overflow: "hidden"
      }, style),
      ref: handleRef
    }, _react.default.createElement("div", {
      style: {
        width: "100%",
        paddingBottom: "".concat(100 / aspectRatio, "%")
      }
    }), bgColor && _react.default.createElement("div", {
      title: title,
      style: {
        backgroundColor: bgColor,
        position: "absolute",
        top: 0,
        bottom: 0,
        opacity: imgLoaded && !isPlaceholder ? 0 : 1,
        transitionDelay: "0.35s",
        right: 0,
        left: 0
      }
    }), !bgColor && _react.default.createElement(Img, {
      src: external ? src : "https://".concat(hostName, "/c_scale,w_20,f_auto/").concat(imageName),
      title: title,
      alt: !isVisible ? alt : '',
      draggable: draggable,
      onDragStart: onDragStart,
      style: _objectSpread(_objectSpread({
        opacity: imgLoaded ? 0 : 1,
        transition: "opacity 0.5s",
        transitionDelay: imgLoaded ? "0.5s" : "0.25s",
        filter: 'blur(1rem)'
      }, imgStyle), placeholderStyle)
    }), isVisible && !isPlaceholder && _react.default.createElement("picture", null, _react.default.createElement("source", {
      srcSet: external ? src : srcSet,
      sizes: "(max-width: ".concat(image.maxWidth, "px) 100vw, ").concat(image.maxWidth, "px")
    }), _react.default.createElement(Img, {
      alt: !isPlaceholder && alt,
      title: title,
      src: external ? src : "https://".concat(hostName, "/").concat(urlParams, "/").concat(imageName),
      srcSet: external ? src : srcSet,
      sizes: "(max-width: ".concat(image.maxWidth, "px) 100vw, ").concat(image.maxWidth, "px"),
      style: imageStyle,
      ref: refImage,
      draggable: draggable,
      onDragStart: onDragStart,
      onLoad: handleImageLoaded,
      onError: onError
    })));
  }

  if (fixed) {
    image = fixed;
    urlParams = "".concat(urlParams, ",w_").concat(image.width, ",h_").concat(image.height);
    srcSet = createBrakePointsFixed(urlParams);

    var divStyle = _objectSpread({
      position: "relative",
      overflow: "hidden",
      width: image.width,
      height: image.height
    }, style);

    if (style.display === "inherit") {
      delete divStyle.display;
    }

    return _react.default.createElement(ImageWrapper, {
      borderRadius: borderRadius,
      hasBorder: hasBorder,
      style: divStyle,
      ref: handleRef
    }, bgColor && _react.default.createElement("div", {
      title: title,
      style: {
        backgroundColor: bgColor,
        width: image.width,
        height: image.height,
        opacity: imgLoaded && !isPlaceholder ? 0 : 1,
        transitionDelay: "0.35s"
      }
    }), !bgColor && _react.default.createElement(Img, {
      src: external ? src : "https://".concat(hostName, "/c_scale,w_20,f_auto/").concat(imageName),
      title: title,
      alt: !isPlaceholder && !isVisible && alt ? alt : ' ',
      draggable: draggable,
      onDragStart: onDragStart,
      style: _objectSpread(_objectSpread({
        opacity: imgLoaded ? 0 : 1,
        transition: 'opacity 0.5s',
        transitionDelay: imgLoaded ? '0.5s' : '0.25s',
        filter: 'blur(1rem)'
      }, imgStyle), placeholderStyle)
    }), isVisible && !isPlaceholder && _react.default.createElement("picture", null, _react.default.createElement("source", {
      srcSet: external ? src : srcSet
    }), _react.default.createElement(Img, {
      alt: !isPlaceholder && alt || ' ',
      title: title,
      width: image.width,
      height: image.height,
      src: "https://".concat(hostName, "/").concat(urlParams, "/").concat(imageName),
      srcSet: external ? src : srcSet,
      style: imageStyle,
      ref: refImage,
      onLoad: handleImageLoaded,
      onError: onError,
      draggable: draggable,
      onDragStart: onDragStart
    })), hasNoScript && _react.default.createElement("noscript", {
      dangerouslySetInnerHTML: {
        __html: noscriptImg(_objectSpread({
          alt: alt,
          title: title
        }, image))
      }
    }));
  }

  return false;
};

Image.defaultProps = {
  fadeIn: true,
  alt: '',
  src: '',
  imgFormat: true,
  quality: true,
  draggable: false,
  onDragStart: function onDragStart(e) {
    e.preventDefault();
  }
};
var _default = Image;
exports.default = _default;